"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./extends-fa579b0f.js"),
  t = require("react"),
  a = require("prop-types"),
  n = require("styled-components"),
  i = require("./assistiveText-80858a8d.js"),
  l = require("./grid-965d799c.js"),
  o = require("./link-8b1ebef7.js"),
  r = require("./taggedTemplateLiteral-97b463ad.js"),
  d = require("polished/lib/helpers/rem"),
  u = require("./picture-b1ad7caa.js"),
  c = require("./typography-fb2881fe.js"),
  g = require("./styles-df7980c2.js");
function s(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var m,
  f,
  h,
  p,
  T,
  b,
  y,
  k,
  x,
  L,
  v,
  w,
  C,
  B,
  _,
  S,
  E,
  I,
  U,
  j,
  q = s(t),
  P = s(a),
  V = s(n),
  F = s(d),
  O = V["default"].div(m || (m = r._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.forFullWidthContainer,
      i = e.imageUrl,
      l = e.disableLazyLoad,
      o = "100%",
      d = "100%",
      u = "relative",
      c = t.largeUp(),
      g = t.mediumDown();
    return a && c && (o = F["default"](460), u = "absolute"), g && (d = F["default"](180)), n.css(f || (f = r._taggedTemplateLiteral(["\n      position: ", ";\n      top: 0;\n      left: 0;\n      height: ", ";\n      width: ", ";\n      background-size: cover;\n      background-position: center;\n      ", ";\n      display: flex;\n      align-items: center;\n      padding: 0;\n    "])), u, d, o, l && n.css(h || (h = r._taggedTemplateLiteral(["background-image: url(", ")"])), i));
  }),
  W = V["default"](o.LinkComponent)(p || (p = r._taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  max-width: unset;\n"]))),
  G = V["default"](l.Col)(T || (T = r._taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  text-align: center;\n  padding: 0;\n"]))),
  H = V["default"].div(b || (b = r._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      a,
      i,
      l = e.component,
      o = e.theme,
      d = e.themeType,
      u = e.backgroundVariant,
      s = e.branding,
      m = e.isFullWidthContainer,
      f = e.withHoverShadow;
    return "darkTheme" === d ? (t = o.colors.action.darkTheme.ctaTextSecondary, a = o.colors.action.darkTheme.ctaTextSecondary, i = o.colors.action.darkTheme.ctaBgSecondaryHover) : (t = o.colors.action.lightTheme.ctaTextSecondary, a = o.colors.action.lightTheme.ctaTextSecondary, i = o.colors.action.lightTheme.ctaBgSecondaryHover), n.css(y || (y = r._taggedTemplateLiteral(["\n      ", ";\n      transition: ", ";\n      background-color: ", ";\n      color: ", ";\n      &:hover {\n        box-shadow: ", ";\n        text-decoration: none;\n        .button-experience-callout-styled {\n          border-color: ", ";\n          color: ", ";\n          background-color: ", ";\n        }\n    "])), !m && "position:relative", o.effects.shadows.transition, g.getSectionBackgroundColor(u, s, o, d), c.getSectionTextColor(l, o, d), f ? o.effects.shadows.hover : "none", t, a, i);
  }),
  z = V["default"](l.Container)(k || (k = r._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.themeType,
      i = e.backgroundVariant,
      l = e.branding,
      o = e.isFullWidthContainer,
      d = e.withBGImage,
      u = "transparent",
      c = t.mediumUp();
    return !o && c || (u = g.getSectionBackgroundColor(i, l, t, a)), n.css(x || (x = r._taggedTemplateLiteral(["\n      background-color: ", ";\n      padding: 0;\n      ", "\n    "])), u, d && !o && "position: relative;");
  }),
  A = V["default"].div(L || (L = r._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.withBGImage,
      i = t.mediumUp(),
      l = "0 ".concat(F["default"](32), " ").concat(F["default"](48));
    return (a || i) && (l = "".concat(F["default"](48), " ").concat(F["default"](32))), n.css(v || (v = r._taggedTemplateLiteral(["\n      padding: ", ";\n      min-height: ", ";\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    "])), l, i ? F["default"](260) : "unset");
  }),
  N = V["default"](c.TypographyComponent)(w || (w = r._taggedTemplateLiteral(["\n  padding-bottom: ", ";\n"])), F["default"](24)),
  D = V["default"].div(C || (C = r._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = 0,
      i = t.mediumDown(),
      l = t.largeDown();
    return i ? a = "".concat(F["default"](40), " ").concat(F["default"](32), " ").concat(F["default"](32)) : l && (a = "0 0 0 ".concat(F["default"](32))), n.css(B || (B = r._taggedTemplateLiteral(["\n      position: relative;\n      height: auto;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      padding: ", ";\n      justify-content: center;\n    "])), a);
  }),
  R = V["default"](u.PictureComponent)(_ || (_ = r._taggedTemplateLiteral(["\n  && {\n    height: ", ";\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n"])), F["default"](200)),
  J = V["default"](l.Row)(S || (S = r._taggedTemplateLiteral(["\n  position: relative;\n"]))),
  K = V["default"].section(E || (E = r._taggedTemplateLiteral(["\n  && {\n    ", "\n  }\n"])), function (e) {
    var t,
      a,
      i,
      l = e.theme,
      o = e.themeType,
      d = e.backgroundVariant,
      u = e.branding,
      c = e.hasFullWidthContainer,
      s = e.disableBottomPadding,
      m = l.mediumUp(),
      f = l.xlargeUp();
    return c ? (t = 0, a = 0, i = 0) : m ? (t = F["default"](60), a = s ? 0 : F["default"](60)) : (t = F["default"](50), a = s ? 0 : F["default"](50)), c || (i = f ? 0 : m ? F["default"](16) : F["default"](12)), n.css(I || (I = r._taggedTemplateLiteral(["\n      position: relative;\n      padding-left: ", ";\n      padding-right: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n      max-width: unset;\n      background-color: ", ";\n      @media print {\n        display: none;\n      }\n    "])), i, i, t, a, g.getSectionBackgroundColor(d, u, l, o));
  }),
  M = V["default"](c.TypographyComponent)(U || (U = r._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      a = e.theme,
      i = e.hasCopy,
      l = a.mediumUp();
    return t = i ? l ? F["default"](16) : F["default"](12) : F["default"](24), n.css(j || (j = r._taggedTemplateLiteral(["\n      padding-bottom: ", ";\n    "])), t);
  }),
  Q = q["default"].forwardRef(function (a, r) {
    var d,
      u,
      c,
      g = a.actionId,
      s = a.ariaLabel,
      m = a.assistiveText,
      f = a.backgroundVariant,
      h = a.branding,
      p = a.buttonText,
      T = a.calloutBackgroundVariant,
      b = a.calloutThemeType,
      y = a.className,
      k = a.descriptionText,
      x = a.disableBottomPadding,
      L = a.disableLazyLoad,
      v = a.headingText,
      w = a.illustration,
      C = a.imageAltText,
      B = a.imageUrl,
      _ = a.isFullWidth,
      S = a.isInternalPdf,
      E = a.isOutgoingLink,
      I = a.linkUrl,
      U = a.moduleName,
      j = a.sectionId,
      P = a.themeType,
      V = a.withBGImage,
      Q = a.withHoverShadow,
      X = (d = t.useContext(n.ThemeContext), u = d.mediumUp(), {
        IllustrationExperienceCalloutStyled: {
          display: "flex",
          width: c = d.largeUp() ? "80%" : "100%",
          height: c,
          maxHeight: u ? "unset" : F["default"](180),
          justifyContent: "center"
        }
      }),
      Y = w;
    return q["default"].createElement(K, {
      id: j,
      ref: r,
      className: y,
      backgroundVariant: f,
      branding: h,
      "data-module": "".concat(j, ":").concat(U, ":A"),
      disableBottomPadding: x,
      hasFullWidthContainer: _,
      themeType: P
    }, q["default"].createElement(z, {
      backgroundVariant: T,
      isFullWidthContainer: _,
      withBGImage: V,
      branding: h
    }, q["default"].createElement(H, {
      backgroundVariant: T,
      branding: h,
      isFullWidthContainer: _,
      themeType: b,
      withHoverShadow: Q
    }, q["default"].createElement(J, {
      align: "center"
    }, q["default"].createElement(G, {
      medium: 5
    }, V ? q["default"].createElement(O, {
      className: "nmx-experience-callout-image-container lazy",
      "data-bg": "url(".concat(B, ")"),
      disableLazyLoad: L,
      forFullWidthContainer: _,
      imageUrl: B
    }) : q["default"].createElement(D, {
      forFullWidthContainer: _
    }, w ? q["default"].createElement(Y, {
      style: X.IllustrationExperienceCalloutStyled
    }) : q["default"].createElement(R, {
      src: B,
      altText: C
    }))), q["default"].createElement(l.Col, {
      align: "center",
      medium: 7
    }, q["default"].createElement(A, {
      withBGImage: V
    }, q["default"].createElement(M, {
      component: "h2",
      hasCopy: k,
      disableBottomPadding: !0,
      themeType: b
    }, v), k && q["default"].createElement(N, {
      disableBottomPadding: !0,
      themeType: b
    }, k), q["default"].createElement(o.LinkComponent, e._extends({
      id: "".concat(j, "-button")
    }, !_ && {
      className: "button-experience-callout-styled"
    }, {
      ariaLabel: s,
      backgroundVariant: T,
      isInternalPdf: S,
      isOutgoingLink: E,
      linkUrl: I,
      themeType: b,
      variant: "buttonLinkSecondary"
    }), p))), !_ && q["default"].createElement(W, {
      id: "".concat(j, "-button"),
      ariaLabel: m,
      "data-tracking-id": g,
      isInternalPdf: S,
      isOutgoingLink: E,
      linkUrl: I,
      themeType: b,
      variant: "buttonLinkSecondary"
    }, q["default"].createElement(i.AssistiveTextComponent, null, m))))));
  });
Q.propTypes = {
  actionId: P["default"].string,
  assistiveText: P["default"].string,
  backgroundVariant: P["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: P["default"].oneOf(["nm", "pcg"]),
  buttonText: P["default"].string.isRequired,
  calloutBackgroundVariant: P["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  calloutThemeType: P["default"].oneOf(["lightTheme", "darkTheme"]),
  className: P["default"].string,
  descriptionText: P["default"].string,
  disableBottomPadding: P["default"].bool,
  disableLazyLoad: P["default"].bool,
  illustration: P["default"].any,
  imageUrl: P["default"].oneOfType([P["default"].string, P["default"].object]),
  imageAltText: P["default"].string,
  isFullWidth: P["default"].bool,
  isInternalPdf: P["default"].bool,
  isOutgoingLink: P["default"].bool,
  headingText: P["default"].oneOfType([P["default"].string, P["default"].object]),
  linkUrl: P["default"].string.isRequired,
  withBGImage: P["default"].bool,
  withHoverShadow: P["default"].bool,
  moduleName: P["default"].string,
  sectionId: P["default"].string.isRequired,
  themeType: P["default"].oneOf(["lightTheme", "darkTheme"]),
  variant: P["default"].oneOf(["withBgImage"])
}, Q.defaultProps = {
  backgroundVariant: "lightA",
  branding: "nm",
  buttonText: "Get Started",
  calloutBackgroundVariant: "lightB",
  calloutThemeType: "lightTheme",
  disableBottomPadding: !1,
  disableLazyLoad: !1,
  isFullWidth: !0,
  linkUrl: "https://northwesternmutual.com/",
  themeType: "lightTheme",
  withBGImage: !0,
  withHoverShadow: !1
};
var X = n.withTheme(Q);
exports.ExperienceCallout = X;